import { useDidMount } from 'beautiful-react-hooks';
import useVersionStore from './version.store';

const CURRENT_VERSION = process.env.ENV_CURRENT_VERSION ?? '';

const useVersion = (): string | undefined => {
  const { setVersion, version } = useVersionStore();

  useDidMount(() => {
    if (!version) {
      let versionToStore = CURRENT_VERSION;

      if (versionToStore === '' && window.location.hostname !== 'localhost') {
        versionToStore = `staging`;
      }

      setVersion(versionToStore);
    }
  });

  return version?.trim();
};

export { useVersion as default };
